import type { SuggestionMenuHandle } from "./types";

interface HandleSuggestionMenuKeyDownOptions {
  key: string;
  menu: SuggestionMenuHandle;
  onDismiss: () => void;
}

export const handleSuggestionMenuKeyDown = ({
  key,
  menu,
  onDismiss,
}: HandleSuggestionMenuKeyDownOptions): boolean => {
  switch (key) {
    case "ArrowDown":
      menu.moveDown();
      return true;
    case "ArrowUp":
      menu.moveUp();
      return true;
    case "Enter":
      return menu.selectActive();
    case "Escape":
      onDismiss();
      return true;
    default:
      return false;
  }
};
